"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileNewbuildingPromoCarousel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _actionAfterViewedComponent = require("@cian/action-after-viewed-component");
var _clsx = require("clsx");
var _react2 = require("swiper/react");
var _useQueryManager = require("../../hooks/useQueryManager");
var _Skeleton = require("../Skeleton");
var _MobileNewbuildingCard = require("../MobileNewbuildingCard");
var _useSlidesVisibility = require("../../hooks/useSlidesVisibility");
require("swiper/css");
var styles = _interopRequireWildcard(require("./styles.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const requiredVisibilityPercentHorizontal = 0.5;
const requiredVisibilityPercentVertical = 0.8;
const MobileNewbuildingPromoCarouselComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    ids,
    fetchData,
    fetchStep = 5,
    indent,
    stretchAloneElement,
    onNewbuildingClick,
    onNewbuildingsShown
  } = props;
  const swiper = React.useRef(null);
  const isUpdatingSlide = React.useRef(false);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const {
    items
  } = (0, _useQueryManager.useQueryManager)({
    fetchData,
    ids,
    currentIndex,
    fetchStep,
    mobile: true
  });
  const {
    checkSlidesVisibility,
    recalculateVisibleSlidesCount
  } = (0, _useSlidesVisibility.useSlidesVisibility)({
    swiper,
    newbuildings: items,
    requiredVisibilityPercentHorizontal,
    requiredVisibilityPercentVertical,
    onVisibilityChange: onNewbuildingsShown
  });
  const setSwiper = React.useCallback(newSwiper => {
    swiper.current = newSwiper;

    // swiper неверно рассчитывает translate, если слайдов больше 1 и все слайды помещаются во вьюпорт
    if (newSwiper.realIndex === 0 && newSwiper.getTranslate() === 0 && indent !== 0) {
      newSwiper.setTranslate(indent);
    }
  }, [indent]);
  const alone = ids.length === 1 && stretchAloneElement;
  const handleClick = React.useCallback((event, index, item) => {
    event.preventDefault();
    onNewbuildingClick({
      position: index,
      newbuilding: item
    });
    window.open(item.url, '_blank');
  }, [onNewbuildingClick]);
  const slides = React.useMemo(() => {
    return items.map((item, index) => /*#__PURE__*/React.createElement(_react2.SwiperSlide, {
      key: item.id,
      className: (0, _clsx.clsx)(styles['slide'], alone && styles['slide--alone'])
    }, _ref => {
      let {
        isVisible
      } = _ref;
      if (item.isLoaded) {
        return /*#__PURE__*/React.createElement(_MobileNewbuildingCard.MobileNewbuildingCard, (0, _extends2.default)({}, item, {
          onClick: handleClick,
          position: index
        }));
      }
      return isVisible && /*#__PURE__*/React.createElement(_Skeleton.Skeleton, {
        mobile: true
      });
    }));
  }, [items, alone, handleClick]);
  const onSlideChange = React.useCallback(swiper => {
    if (isUpdatingSlide.current) {
      return;
    }
    checkSlidesVisibility();
    setCurrentIndex(swiper.realIndex);
  }, [checkSlidesVisibility]);
  const resetCurrentSlide = React.useCallback(() => {
    isUpdatingSlide.current = true;
    if (swiper.current) {
      setCurrentIndex(0);
      swiper.current.slideTo(0);
    }
    isUpdatingSlide.current = false;
  }, []);
  React.useImperativeHandle(ref, () => ({
    resetCurrentSlide
  }));
  const onOrientationchange = React.useCallback(() => {
    // hack: необходимо дождаться полного репейнта после orientation change, потому что моментальный вызов update не приводит к пересчету translate
    setTimeout(() => {
      swiper.current?.update();
      recalculateVisibleSlidesCount();
      checkSlidesVisibility();
    }, 100);
  }, [checkSlidesVisibility, recalculateVisibleSlidesCount]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(_actionAfterViewedComponent.ActionAfterViewObserver, {
    callback: checkSlidesVisibility,
    percentVisible: requiredVisibilityPercentVertical,
    triggerOnce: false
  }, /*#__PURE__*/React.createElement(_react2.Swiper, {
    allowTouchMove: ids.length > 1,
    "data-testid": "mobile_swiper",
    spaceBetween: 16,
    updateOnWindowResize: true,
    watchSlidesProgress: true,
    slidesPerView: "auto",
    height: 340,
    className: styles['swiper'],
    slidesOffsetBefore: indent,
    onSwiper: setSwiper,
    onSlideChange: onSlideChange,
    onOrientationchange: onOrientationchange
  }, slides))));
});
MobileNewbuildingPromoCarouselComponent.displayName = 'MobileNewbuildingPromoCarouselComponent';
const MobileNewbuildingPromoCarousel = exports.MobileNewbuildingPromoCarousel = /*#__PURE__*/React.memo(MobileNewbuildingPromoCarouselComponent);